import axios from 'axios';
import _ from 'lodash';
import {List} from 'immutable';
import {Organization, NavItem} from '../models';

export default class JSONLDSource {
  static __localOrRemote() {
    const remoteJSONLD = () => {
      return axios
        .get('/.jsonld')
        .then(response => Promise.resolve(response.data));
    };
    const localJSONLD = _.first(
      _.filter(document.getElementsByTagName('script'), element => {
        const value = _.get(element, 'attributes.type.value');
        return !_.isNil(value) && value === 'application/ld+json';
      })
    );
    if (_.isNil(localJSONLD) || _.isNil(localJSONLD.innerHTML))
      return remoteJSONLD();
    const value = _.trim(localJSONLD.innerHTML);
    if (_.isEmpty(value) || value === '$JSONLDApp') return remoteJSONLD();
    return Promise.resolve(JSON.parse(value));
  }
  /**
   * Fetch the next JSONLD document from server.
   * Will parse the document, and bootstrap the Page store.
   * @return {Promise}
   */
  static fetch() {
    return JSONLDSource.__localOrRemote()
      .then(data => {
        // Parse the graph tree in a JSON dictionnary
        const graph = data['@graph'];
        const parsed = {};
        _.forEach(graph, node => {
          const nodeType = node['@type'];
          if (!_.has(parsed, nodeType)) {
            parsed[nodeType] = [];
          }
          parsed[nodeType].push(_.merge(node, {id: node['@id']}));
        });
        _.forEach(parsed, (nodes, nodeType) => {
          parsed[nodeType] = _.uniqBy(nodes, node => node.id);
        });
        return Promise.resolve(parsed);
      })
      .then(parsedGraph => {
        const store = {};
        const postalAddress = _.first(parsedGraph['PostalAddress']);
        const organization = _.first(parsedGraph['Organization']);
        store.organization = new Organization({
          name: organization.name ? organization.name : '',
          legalName: organization.legalName ? organization.legalName : '',
          addressLocality: postalAddress.addressLocality
            ? postalAddress.addressLocality
            : '',
          postalCode: postalAddress.postalCode ? postalAddress.postalCode : '',
          streetAddress: postalAddress.streetAddress
            ? postalAddress.streetAddress
            : '',
          addressRegion: postalAddress.addressRegion
            ? postalAddress.addressRegion
            : '',
          addressCountry: postalAddress.addressCountry
            ? postalAddress.addressCountry
            : '',
        });
        const website = _.first(parsedGraph['Website']);
        store.siteTitle = website.name;
        store.siteHref = website.url;

        const webpage = _.first(parsedGraph['Webpage']);
        store.language = webpage.inLanguage;
        store.pageTitle = webpage.name;
        store.created_at = new Date(webpage.dateCreated);
        store.updated_at = new Date(webpage.dateModified);
        store.published_at = new Date(webpage.datePublished);

        store.navigation = new List(
          parsedGraph['SiteNavigationElement'].map(nav => {
            let urlTransformed = nav.url.replace('://', '');
            urlTransformed = urlTransformed.substr(urlTransformed.indexOf('/'));
            return new NavItem({
              id: nav.id,
              url: urlTransformed,
              name: nav.name,
            });
          })
        );
        return Promise.resolve(store);
      });
  }
}



// WEBPACK FOOTER //
// ./src/sources/JSONLDSource.js